import CacheDeletion from "../../components/CacheDelete/CacheDeletion";
import Header from "../../components/Header/Header";
import SideNavbar from "../../components/Navbar/SideNavbar";

const CacheDelete = () => {
    return (
        <>
            <div className="flex mainWrapper w-full">
                <div className="sidenav-wrapper">
                    <SideNavbar />
                </div>
                <div className="right-container">
                    <div className="header-container">
                        <Header />
                    </div>
                    <div className="body-container">
                        <CacheDeletion />
                    </div>
                </div>
            </div>
        </>
    )
}
export default CacheDelete;